import { Component } from "@angular/core";

@Component({
  selector: "snt-report-form-renderer-customer-signature",
  templateUrl: "report-form-renderer-customer-signature.component.html",
  styles: `
    :host {
      display: flex;
      flex: 1;
    }
  `,
  standalone: false
})
export class ReportFormRendererCustomerSignatureComponent {
  async renderPdfObject(): Promise<Record<string, any>> {
    return {
      type: "customer-signature",
      config: {}
    };
  }
}
